import React from "react";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./screens/customer/home/Home";
import AboutUs from "./screens/customer/about/AboutUs";
import ContactUs from "./screens/customer/contact/ContactUs";
import TermsAndConditions from "./screens/customer/legal/TermsAndConditions";
import ProductsPage from "./screens/customer/productPage/ProductsPage";
import SingleProductDetailPage from "./subscreens/customer/productPage/SingleProductDetailPage.js";
import Shops from "./screens/customer/shop/Shops";
import BlogPage from "./subscreens/customer/blogs/BlogsPage.js";
import SingleBlogPage from "./subscreens/customer/blogs/SingleBlogPage.js";
import Business from "./screens/customer/business/Business";
import ShopDetails from "./subscreens/customer/shop/shopdetails/ShopDetails.js";
import Chatbot from "./components/general/chatbot/Chatbot";

//  Admin Imports

import Analytics from "./screens/admin/analytics/Analytics";
import SystemSettings from "./screens/admin/settings/SystemSettings";
import CategoriesList from "./screens/admin/categories/CategoriesList";
import OrdersList from "./screens/admin/orders/OrdersList";
import CustomersList from "./screens/admin/customers/CustomersList";
import ProductsList from "./screens/admin/products/ProductsList";
import Dashboard from "./screens/admin/dashboard/Dashboard.js";
import HelpAndSupport from "./screens/admin/help/HelpAndSupport.js";
import AdminMessages from "./screens/admin/messages/AdminMessages.js";
import AdminNotifications from "./screens/admin/notifications/AdminNotifications.js";
import BlogsList from "./screens/admin/blogs/BlogsList.js";
import AdminLogin from "./screens/admin/auth/AdminLogin.js";
import SubAdminsList from "./screens/admin/subadmins/SubAdminsList.js";
import SellersList from "./screens/admin/seller/SellersList.js";
import Payouts from "./screens/admin/payout/Payouts.js";
import FAQs from "./screens/admin/faqs/FAQs.js";

// customer imports
import CustomerDashboard from "./screens/customerDashboard/CustomerDashboard.js";
import Profile from "./screens/customerDashboard/Profile.js";
import Orders from "./screens/customerDashboard/Orders.js";
import CustomerMessages from "./screens/customerDashboard/CustomerMessages.js";
import Wishlist from "./screens/customerDashboard/Wishlist.js";
import Help from "./screens/customerDashboard/Help.js";
import CustomerCart from "./screens/customerDashboard/CustomerCart.js";
import Notifications from "./screens/customerDashboard/CustomerNotifications.js";
import Login from "./screens/customer/auth/login/Login.js";
import Register from "./screens/customer/auth/register/Register.js";
import NotFound from "./components/general/notFound/NotFound.js";
import OrderDetails from "./screens/customerDashboard/OrdersDetails.js";

//Seller
import SellerDashboard from "./screens/seller/dashboard/SellerDashboard.js";
import SellerProducts from "./screens/seller/products/SellerProducts.js";
import SellerOrders from "./screens/seller/orders/SellerOrders.js";
import SellerEarnings from "./screens/seller/earnings/SellerEarnings.js";
import SellerReviews from "./screens/seller/reviews/SellerReviews.js";
import SellerSupport from "./screens/seller/support/SellerSupport.js";
import SellerSettings from "./screens/seller/settings/SellerSettings.js";
import SellerRegister from "./screens/seller/auth/register/SellerRegister.js";
import SellerLogin from "./screens/seller/auth/login/SellerLogin.js";
import SellerMessages from "./screens/seller/message/SellerMessages.js";
import SellerNotifications from "./screens/seller/notification/SellerNotifications.js";
import SellerAnalytics from "./screens/seller/analytics/SellerAnalytics.js";
import DeliveryRegister from "./screens/delivery/auth/DeliveryRegister.js";
import DeliveryLogin from "./screens/delivery/auth/DeliveryLogin.js";
import DeliveryEarningsWallet from "./screens/delivery/earning/DeliveryEarningsWallet.js";

import DeliveryLayout from "./layouts/DeliveryPanelLayout.js";
import MyJobs from "./screens/delivery/myJobs/MyJobs.js";
import DeliveryMessages from "./screens/delivery/deliveryMessages/DeliveryMessages.js";
import DeliveryNotifications from "./screens/delivery/deliveryNotifications/DeliveryNotifications.js";
import DeliverySupport from "./screens/delivery/deliverySupport/DeliverySupport.js";
import DeliverySettings from "./screens/delivery/setting/DeliverySetting.js";
import DeliveryMen from "./screens/admin/delivery/DeliveryMen.js";
import PaymentSuccess from "./screens/customerDashboard/stripe/PaymentSuccess.js";
import DeliveryTopup from "./screens/admin/topup/DeliveryTopup.js";
import RoleSelect from "./components/general/roleSelect/RoleSelect.js";
import Vehicles from "./screens/admin/vehicles/Vehicles.js";
import OpenJobs from "./screens/delivery/openJobs/OpenJobs.js";
import CustomerOrderBids from "./screens/customerDashboard/CustomerOrderBids.js";
import ForgotPassword from "./components/general/forgotPassword/ForgotPassword.js";
import PrivacyPolicy from "./screens/customer/legal/PrivacyPolicy.js";

function App() {
  return (
    <>
      <Routes>
        {/* ============================================
              HOME ROUTES
        ============================================  */}

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy/>}/>
        <Route path="/business" element={<Business />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/shops" element={<Shops />} />
        <Route path="/shop-details" element={<ShopDetails />} />
        <Route path="/product-detail" element={<SingleProductDetailPage />} />
        <Route path="/blogs" element={<BlogPage />} />
        {/* <Route path="/blog" element={<SingleBlogPage />} /> */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<SingleBlogPage />} />
        <Route path="/role-select" element={<RoleSelect />} />

        {/* ============================================
               CUSTOMER DASHBOARD ROUTES
         ============================================  */}
        <Route path="/customer/login" element={<Login />} />
        <Route path="/customer/register" element={<Register />} />
        <Route
          path="/customer"
          element={<Navigate to="/customer/dashboard" replace />}
        />
        <Route path="/customer/dashboard" element={<CustomerDashboard />} />
        <Route path="/customer/profile" element={<Profile />} />
        <Route path="/customer/orders" element={<Orders />} />
        <Route path="/customer/order-details" element={<OrderDetails />} />
        <Route path="/customer/messages" element={<CustomerMessages />} />
        <Route path="/customer/profile" element={<Profile />} />
        <Route path="/customer/wishlist" element={<Wishlist />} />
        <Route path="/customer/notifications" element={<Notifications />} />
        <Route path="/customer/help" element={<Help />} />
        <Route path="/customer/cart" element={<CustomerCart />} />
        <Route path="/customer/payment-success" element={<PaymentSuccess />} />

        <Route path="/customer/roleSelect" element={<RoleSelect />} />
        <Route path="/customer/order-bids" element={<CustomerOrderBids />} />
        {/* <Route path="/customer/payment-success" element={<PaymentSuccess />} /> */}
        {/* <Route path="/customer/payment-failure" element={<PaymentFailure />} />
        <Route path="/customer/payment-cancelled" element={<PaymentCancelled />} /> */}
        <Route path="*" element={<NotFound />} />
        {/* ============================================
               ADMIN DASHBOARD ROUTES
         ============================================  */}

        <Route path="admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={<Navigate to="/admin/dashboard" replace />}
        />

        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/analytics" element={<Analytics />} />
        <Route path="/admin/settings" element={<SystemSettings />} />
        <Route path="/admin/categories" element={<CategoriesList />} />
        <Route path="/admin/orders" element={<OrdersList />} />
        <Route path="/admin/customers" element={<CustomersList />} />
        <Route path="/admin/products" element={<ProductsList />} />
        <Route path="/admin/help-support" element={<HelpAndSupport />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
        <Route path="/admin/notifications" element={<AdminNotifications />} />
        <Route path="/admin/blogs" element={<BlogsList />} />
        <Route path="/admin/sub-admins" element={<SubAdminsList />} />
        <Route path="/admin/sellers" element={<SellersList />} />
        <Route path="/admin/payout-requests" element={<Payouts />} />
        <Route path="/admin/faqs" element={<FAQs />} />
        <Route path="/admin/delivery" element={<DeliveryMen />} />
        <Route path="/admin/topup" element={<DeliveryTopup />} />
        <Route path="/admin/vehicles" element={<Vehicles />} />

        {/* ============================================
              SELLER DASHBOARD ROUTES
         ============================================  */}

        <Route path="/seller/register" element={<SellerRegister />} />
        <Route path="/seller/login" element={<SellerLogin />} />
        <Route
          path="/seller"
          element={<Navigate to="/seller/dashboard" replace />}
        />
        <Route path="/seller/dashboard" element={<SellerDashboard />} />
        <Route path="/seller/products" element={<SellerProducts />} />
        <Route path="/seller/orders" element={<SellerOrders />} />
        <Route path="/seller/earnings" element={<SellerEarnings />} />
        <Route path="/seller/reviews" element={<SellerReviews />} />
        <Route path="/seller/analytics" element={<SellerAnalytics />} />
        <Route path="/seller/support" element={<SellerSupport />} />
        <Route path="/seller/settings" element={<SellerSettings />} />
        <Route path="/seller/messages" element={<SellerMessages />} />
        <Route path="/seller/notifications" element={<SellerNotifications />} />
       

        {/* ============================================
               DELIVERY PANEL ROUTES
         ============================================  */}

        <Route path="/delivery/register" element={<DeliveryRegister />} />
        <Route path="/delivery/login" element={<DeliveryLogin />} />
        <Route path="/delivery/earnings" element={<DeliveryEarningsWallet />} />
        {/* <Route path="/delivery-panel/layout" element={<DeliveryLayout />} /> */}
        <Route path="/delivery/open-jobs" element={<OpenJobs/>} />
        <Route path="/delivery/my-jobs" element={<MyJobs />} />
        <Route path="/delivery/messages" element={<DeliveryMessages />} />
        <Route path="/delivery/support" element={<DeliverySupport />} />
        <Route
          path="/delivery/notifications"
          element={<DeliveryNotifications />}
        />
        <Route path="/delivery/settings" element={<DeliverySettings />} />
        {/* general Forgot Password */}
         <Route path="/:role/forgot-password" element={<ForgotPassword />} />
      </Routes>
     
    </>
  );
}

export default App;
